import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import Home from './pages/Home';
import DashboardLayout from './components/DashboardLayout';
import DashboardPage from './pages/DashboardPage';
import CreativesPage from './pages/CreativesPage';
import TemplatesPage from './pages/TemplatesPage';
import EditorPage from './pages/EditorPage';
import XmlTesterPage from './pages/XMLTesterPage';
import CampaignPage from './pages/CampaignPage';
import CreativeFlow from './pages/CreativeFlow';
import LoginPage from './pages/auth/LoginPage';
import SignupPage from './pages/auth/SignupPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';
import Profile from './pages/Profile';
import ChangePassword from './pages/ChangePassword';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Contact from './pages/Contact';
import Support from './pages/Support';
import About from './pages/About';
import QRDesigner from './pages/QREditor';

function App() {
  return (

    <>
      <BrowserRouter>
        <Routes>

          {/* Public Home */}
          <Route path="/" element={<Home />} />

          {/* Dashboard Layout Routes */}
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="projects" element={<DashboardPage />} />
            <Route path="templates" element={<TemplatesPage />} />
            <Route path="analytics" element={<DashboardPage />} />
            <Route path="team" element={<DashboardPage />} />
            <Route path="settings" element={<DashboardPage />} />
            <Route path="editor" element={<EditorPage />} /> {/* ✅ Fixed */}
          </Route>

          {/* Creatives under same layout */}
          <Route path="/creatives" element={<DashboardLayout />}>
            <Route index element={<CreativesPage />} />
          </Route>

          <Route path="/templates" element={<DashboardLayout />}>
            <Route index element={<TemplatesPage />} />
          </Route>

          <Route path="/xml-tester" element={<DashboardLayout />}>
            <Route index element={<XmlTesterPage />} />
          </Route>

          <Route path="/qr-generator" element={<DashboardLayout />}>
            <Route index element={<QRDesigner />} />
          </Route>

          <Route path="/campaign" element={<DashboardLayout />}>
            <Route index element={<CampaignPage />} />
          </Route>

          <Route path="/creative-flow" element={<DashboardLayout />}>
            <Route index element={<CreativeFlow />} />
          </Route>

          <Route path="/profile" element={<DashboardLayout />}>
            <Route index element={<Profile />} />
          </Route>

          <Route path="/change-password" element={<DashboardLayout />}>
            <Route index element={<ChangePassword />} />
          </Route>



          {/* Redirects */}
          <Route path="/demos" element={<Navigate to="/dashboard/editor" replace />} />

          <Route path="/sign-in" element={<LoginPage />} />
          <Route path="/sign-up" element={<SignupPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password/:token" element={<ResetPasswordPage />} />

          <Route path="/support" element={<Support />} />
          <Route path="/contact" element={<Contact />} />

          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />

          <Route path="/about" element={<About />} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />

        </Routes>
      </BrowserRouter>

    </>

  );
}

export default App;
